import { getOfficialDrawDate } from "@/lib/date";
import { Promotion } from "../models/giveaway";

function GiveawayDetails({ promotion }: { promotion: Promotion }) {
	const endDate = new Date(promotion.endDate).toLocaleDateString("en-US", {
		year: "numeric",
		month: "long",
		day: "numeric",
	});

	const titleStyle = {
		background:
			"linear-gradient(161deg, #0FF1E5 3.9%, #0DAAEC 33.24%, #0823F8 72.3%, #000D74 116.02%)",
		WebkitBackgroundClip: "text",
		backgroundClip: "text",
		WebkitTextFillColor: "transparent",
	};

	return (
		<div className="max-sm:bg-blue flex flex-col-reverse items-center gap-8 px-4 py-16 md:flex-row md:gap-16 md:px-37 md:py-50">
			<div className="flex flex-col gap-8">
				<span className="web-heading-h2">
					<span style={titleStyle}>Giveaway</span> Details
				</span>
				<div className="flex flex-col gap-6">
					<p className="web-body-b1 text-gray-700">
						Entries close on {endDate}, at 11:59 PM, so make sure to get yours
						in before the deadline! The official draw will take place on
						{" " + getOfficialDrawDate(promotion.endDate)}, at 7:00 PM, and we’ll be streaming it live on
						Instagram. <br /> <br />
						Don’t miss the excitement—tune in as we reveal the lucky winners!
						You could be walking away with one of these amazing prizes!
					</p>
					<div className="flex flex-col gap-3">
						<span className="web-body-b1">
							<span className="web-body-b1-medium">Date:</span>{" "}
							{getOfficialDrawDate(promotion.endDate)}
						</span>
						<span className="web-body-b1">
							<span className="web-body-b1-medium">Time:</span> 7:00 PM
						</span>
						<span className="web-body-b1">
							<span className="web-body-b1-medium">Where:</span> Instagram Live
							Stream
						</span>
					</div>
					<p className="web-body-b1-medium text-blue-500">
						Enter now and get ready to reel in something big!
					</p>
				</div>
			</div>
		</div>
	);
}

export default GiveawayDetails;
